/*

NOTE: tag is not supported in horizontal menu

Array of object

Top level object can be:
2. Group (Group can have navItems as children)
3. navItem

* Supported Options

/--- nav Grp (top level grp is called header group) ---/

title
icon (if it's on top/second level)
children

/--- nav Item (top level item is called header link) ---/

icon (if it's on top/second level)
title
route: [route_obj/route_name] (I have to resolve name somehow from the route obj)

*/

import ngoProfile from "./ngo-profile";
import programs from "./programs";
import ministryRelation from "./ministry-relation";
import organization from "./organization";
import techSupport from "./tech-support";
import guestPages from "./guest-pages";
import properties from "./properties";
import tashbeek from "./tashbeek";
import transactions from "./transactions";

// Array of sections
var fullAccessNav = [
  ...ngoProfile,
  ...programs,
  ...organization,
  ...properties,
  ...ministryRelation,
  ...guestPages,
  ...tashbeek,
  ...techSupport,
  ...transactions,
];

export default fullAccessNav;
